import './OrgDetailStorage.css'

import { WrappedPagination } from '@makyoapp/makyo-ui'

import { StorageProvider, useStorageContext } from '@/context/StorageContext'
import { WrapperProps } from '@/shared/routes'
import { StorageStats } from '@/pages/org/storage/components/StorageStats'
import Layout from '@/components/Layout'

import { StorageAction } from './components/StorageAction'
import { StorageFileList } from './components/StorageFileList'
import { StorageFoldersSection } from './components/StorageFoldersSection'
import { StoragePreview } from './components/StoragePreview'

function OrgDetailStorageLayout(props: WrapperProps) {
  const { search, setSearch, resetParams, storage, page, setPage, isLoadingFiles, isLoadingFolders } =
    useStorageContext()

  return (
    <Layout
      {...props}
      search={search}
      onSearch={setSearch}
      onClearSearch={resetParams}
      actions={<StorageAction />}
      wrapClassName='w-full min-h-[86vh]'
    >
      <div className='flex flex-col xl:flex-row items-start gap-8'>
        <div className='w-full'>
          {/* Storage Folders Section */}
          <StorageFoldersSection />

          <div className='mt-16'>
            {/* Storage File List Section */}
            <StorageFileList />

            {/* Pagination */}
            <WrappedPagination
              totalCount={storage.totalCount}
              page={page}
              perPage={20}
              onChange={(f, t, p) => {
                if (page !== p) {
                  setPage(p)
                }
              }}
            />
          </div>
        </div>

        {/* Storage Stats Section */}
        <StorageStats />
      </div>

      {/* Modal of StoragePreview */}
      <StoragePreview />
    </Layout>
  )
}

/**
 * Org Storage Page
 *
 * @route `o/:orgId/storge`
 *
 */
export default function OrgDetailStorage(props: WrapperProps) {
  return (
    <StorageProvider>
      <OrgDetailStorageLayout {...props} />
    </StorageProvider>
  )
}
